module.exports = __webpack_public_path__ + "img/LabyMatch.61a4562c.png";